// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2flo2","label":"LabeledBox_label__3G9OZ"};